import React, { useState } from 'react'
import { Alert, Button, Field } from '../../components/ui'
import { SNAP_MINUTES } from './shared'

/** Opprett/rediger én utleie. */
function SlotForm({ initial, courts, onSubmit, submitting, submitLabel, onCancel, error, isNew }) {
  const [form, setForm] = useState(initial)
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }))
  const submit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }
  return (
    <form className="rt-form" onSubmit={submit}>
      <Field label="Tittel *" className="rt-f-full">
        <input value={form.title} onChange={set('title')} placeholder="F.eks. Hallbooking, PT-time, Fotballøkt" required maxLength={200} />
      </Field>
      <Field label="Hall" className="rt-f-half">
        <select value={form.courtId} onChange={set('courtId')}>
          <option value="">Ingen bestemt hall</option>
          {courts.map((c) => (
            <option key={c.id} value={c.id}>{c.name}{c.floor ? ` (${c.floor})` : ''}</option>
          ))}
        </select>
      </Field>
      <Field label="Synlighet" className="rt-f-half">
        <select value={form.visibility} onChange={set('visibility')}>
          <option value="FOLLOWERS">Kun følgere av arenaen</option>
          <option value="PUBLIC">Offentlig – alle</option>
        </select>
      </Field>
      <Field label="Start *" className="rt-f-half">
        <input type="datetime-local" value={form.startsAt} onChange={set('startsAt')} required step={SNAP_MINUTES * 60} />
      </Field>
      <Field label="Slutt *" className="rt-f-half" hint={isNew ? 'Kvarter: :00, :15, :30, :45' : undefined}>
        <input type="datetime-local" value={form.endsAt} onChange={set('endsAt')} required step={SNAP_MINUTES * 60} />
      </Field>
      <Field
        label="Antall plasser *"
        className="rt-f-third"
        hint={isNew ? '1–500. 1 = fullbooket når én har booket.' : '1 = fullbooket når én har booket.'}
      >
        <input type="number" className="input-mono" min={1} max={500} value={form.capacity} onChange={set('capacity')} required />
      </Field>
      <Field label="Pris (kr)" className="rt-f-third" hint="0 = gratis. Betales i appen før bookingen går gjennom.">
        <input type="number" className="input-mono" min={0} step="1" value={form.price} onChange={set('price')} />
      </Field>
      <Field label="Avbestillingsfrist (timer før)" className="rt-f-third" hint="Full refusjon frem til fristen.">
        <input type="number" className="input-mono" min={0} max={720} value={form.cancellationDeadlineHours} onChange={set('cancellationDeadlineHours')} />
      </Field>
      <Field label="Sted" className="rt-f-full">
        <input value={form.locationText} onChange={set('locationText')} placeholder="Standard: arenaens adresse" maxLength={500} />
      </Field>
      <Field label="Info" className="rt-f-full">
        <textarea rows={3} value={form.description} onChange={set('description')} placeholder="Hva er inkludert, hva man bør ta med …" maxLength={5000} />
      </Field>
      {error && <Alert tone="error" className="rt-f-full">{error}</Alert>}
      <div className={`rt-f-full ${onCancel ? 'rt-form-foot' : 'rt-form-inline-actions'}`}>
        {onCancel && <Button variant="tertiary" onClick={onCancel}>Avbryt</Button>}
        <Button type="submit" variant="primary" disabled={submitting}>
          {submitting ? 'Lagrer…' : submitLabel}
        </Button>
      </div>
    </form>
  )
}

export default SlotForm
